module.exports = __webpack_public_path__ + "static/2-05455b17d1b898b785db342ab317a0f3.jpg";